<script setup lang="ts">
  import { computed, onBeforeMount, ref } from 'vue';
  import { useRoute } from 'vue-router';

  import type { DisputeStatus } from '@stuut/api/models';
  import { ComboSelect } from '@ui/components/combo-select';

  interface Props {
    hideOptions?: DisputeStatus[];
    multiple?: boolean;
    options: Record<string, any>[];
    queryName?: string;
  }

  interface StatusOption {
    label: string;
    value: string;
  }

  const props = withDefaults(defineProps<Props>(), {
    multiple: false,
    queryName: 'status',
  });

  const emit = defineEmits<{
    (e: 'update', value: string[]): void;
  }>();

  const route = useRoute();
  const selectedStatus = ref<StatusOption[]>([]);

  const optionsList = computed(() => {
    return props.options?.filter((opt) => !(props.hideOptions || [])?.includes(opt.value));
  });

  onBeforeMount(() => {
    if (route.query?.status) {
      const statusQuery = route.query.status;
      const statusArray = Array.isArray(statusQuery) ? statusQuery : [statusQuery];

      selectedStatus.value = statusArray
        .map((val) => {
          return props.options?.find((option) => option.value === val);
        })
        .filter((option) => option !== undefined) as StatusOption[];
    }
  });

  defineExpose({
    selectedStatus,
  });
</script>

<template>
  <ComboSelect
    v-if="optionsList?.length"
    v-model="selectedStatus"
    :options="optionsList"
    searchable
    variant="filter"
    placeholder="Status"
    :multiple="multiple"
    search-placeholder="Filter by status..."
    option-identifier="label"
    @update:model-value="
      (status) =>
        emit(
          'update',
          Array.isArray(status) ? status?.map((c) => c.value) : status ? [status.value] : [],
        )
    "
  >
    <template #filter-label>
      <i class="fa-regular fa-bars-progress text-xs" />
      <span> Status </span>
    </template>
  </ComboSelect>
</template>
